import React, { useState } from "react";
import { Box, useTheme, Button, CircularProgress } from "@mui/material";
import { logEvent } from "services/amplitude.service";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

const Submit = ({
  edit,
  setEdit,
  addOrUpdateBookmark,
  articleData,
  citation,
  markdownSummary,
  citationLoaded,
  disable,
  levelLoaded,
  markdownLevel,
  summaryLoaded,
  handleSave
}) => {
  const [loading, setLoading] = useState(false);
  const theme = useTheme();
  const navbarBackground = theme.palette?.navbar?.main;

  const { summaryInfoData } = useSelector((state) => state.data);

  const handleSubmit = async () => {
    setLoading(true);
    try {
      await addOrUpdateBookmark(
        articleData,
        citation,
        markdownSummary,
        citationLoaded,
        levelLoaded,
        markdownLevel,
        summaryLoaded
      );
      logEvent("click_bookmark_save", { click: true, url: summaryInfoData.url });
      handleSave();
      setEdit(false);
    } catch (error) {
      toast.error("Failed to save bookmark");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: "secondary.main",
        display: "grid",
        gridTemplateColumns: edit ? "1fr 1fr" : "1fr",
        gap: 5,
        p: 2,
      }}
    >
      {edit && (
        <Button
          onClick={() => setEdit(false)}
          variant="outlined"
          disabled={loading}
          sx={{
            display: "flex",
          }}
        >
          Cancel
        </Button>
      )}
      <Button
        onClick={handleSubmit}
        disabled={disable || loading}
        sx={{
          display: "flex",
          gap: 1,
          gridColumn: !edit ? "1 / -1" : "unset",
          justifySelf: !edit ? "flex-end" : "unset",
        }}
      >
        {loading && <CircularProgress size={20} />}
        Save
      </Button>
    </Box>
  );
};

export default Submit;
